(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sg-affiliate"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('sg-affiliate-experience')) {
    customElements.define('sg-affiliate-experience', class extends HTMLElement {
      connectedCallback() {
        if (this.observer || !('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
        this.observer = new IntersectionObserver(entries => {
          entries.forEach(entry => {
            if (!entry.isIntersecting) return;
            this.observer.unobserve(entry.target);
            if (entry.target.animate && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
              entry.target.animate([{opacity:0,transform:'translateY(14px)'},{opacity:1,transform:'translateY(0)'}],{duration:550,easing:'cubic-bezier(.2,.7,.2,1)'});
            }
          });
        }, {threshold:.12});
        this.querySelectorAll('[data-affiliate-reveal]').forEach(element => this.observer.observe(element));
      }
      disconnectedCallback() {
        if (this.observer) this.observer.disconnect();
        this.observer = null;
      }
    });
  }


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sg-partner-gym"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('sg-gym-experience')) {
    customElements.define('sg-gym-experience', class extends HTMLElement {
      connectedCallback() {
        if (this.observer || !('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
        this.observer = new IntersectionObserver(entries => {
          entries.forEach(entry => {
            if (!entry.isIntersecting) return;
            this.observer.unobserve(entry.target);
            if (entry.target.animate && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
              entry.target.animate([{opacity:0,transform:'translateY(14px)'},{opacity:1,transform:'translateY(0)'}],{duration:550,easing:'cubic-bezier(.2,.7,.2,1)'});
            }
          });
        }, {threshold:.12});
        this.querySelectorAll('[data-gym-reveal]').forEach(element => this.observer.observe(element));
      }
      disconnectedCallback() {
        if (this.observer) this.observer.disconnect();
        this.observer = null;
      }
    });
  }


  } catch(e) { console.error(e); }
})();
})();
